import { Avatar, AvatarGroup } from '@chakra-ui/core';
import { useObserver } from 'mobx-react';
import React from 'react';

import { useStores } from '../hooks/useStores';

function useStoreData() {
    const { store } = useStores();
    return useObserver(() => ({
        users: Array.from(store.users.list.values()),
    }));
}

// TODO: differentiate host and guests, I may be better to have them separated
const UserGuests = () => {
    const { users } = useStoreData();
    return (
        <AvatarGroup size="md" max={5}>
            {users.map(user => (
                <Avatar border="none" key={`userGuest-${user.id}`} name={user.displayName} src={user.photoURL} />
            ))}
        </AvatarGroup>
    );
};

export default UserGuests;
